queryIdCounter